/**
 * Change value in selectbox
 */

document.addEventListener('DOMContentLoaded', () => {
	const customOptions = ['Custom', 'Custom size', 'Custom'].map((item) => item.toLowerCase());

	const updateMeasurementClass = (container) => {
		const selects = container.querySelectorAll('.product-form__input select');
		const variantPicker = container.querySelector('.tpt-product__variant-picker');
		const optionsInput = document.querySelector('[name="properties[Options]"]');

		if (!variantPicker) return;

		const hasCustomOption = [...selects].some((select) => customOptions.includes(select.value.trim().toLowerCase()));

		variantPicker.classList.toggle('tpt-customer__measurement-option', hasCustomOption);

		if (!optionsInput) return;

		if (!hasCustomOption) {
			optionsInput.value = '';
			return;
		}

		const values = [...selects]
			.filter((select) => {
				const optionName = select.name.match(/options\[(.*?)\]/)?.[1] || '';

				return optionName.toLowerCase() !== 'size';
			})
			.map((select) => {
				const wrapper = select.closest('.product-form__input');

				const label = wrapper?.querySelector('.form__label-name')?.textContent.trim();

				const value = select.value.trim();

				return label && value ? `${label}: ${value}` : null;
			})
			.filter(Boolean);

		console.log('values', values);
		optionsInput.value = values.join(', ');
	};

	// Initial check
	document.querySelectorAll('.product__info-container').forEach((container) => updateMeasurementClass(container));

	// Change event
	document.addEventListener('change', (event) => {
		const select = event.target;

		if (!select.matches('.product-form__input select')) return;

		const container = select.closest('.product__info-container');

		if (!container) return;

		updateMeasurementClass(container);
	});
});

/** End */

if (!customElements.get('tpt-measurement')) {
	customElements.define(
		'tpt-measurement',
		class TptMeasurement extends HTMLElement {
			constructor() {
				super();

				this.currentUnit = window.tptMeasurementUnit || 'in';

				this.initUnits();
				this.syncActiveStates();
			}

			/**
			 * Convert unit
			 */

			initUnits() {
				console.log('THIS', this);
				const unitButtons = this.querySelectorAll('tpt-measurement-unit');

				unitButtons.forEach((button) => {
					button.addEventListener('click', () => {
						const newUnit = button.dataset.unit;

						if (newUnit === this.currentUnit) return;

						this.convertAllMeasurements(this.currentUnit, newUnit);

						this.currentUnit = newUnit;
						window.tptMeasurementUnit = newUnit;

						this.syncActiveStates();
					});
				});
			}

			syncActiveStates() {
				const unitButtons = this.querySelectorAll('tpt-measurement-unit');

				unitButtons.forEach((button) => {
					button.classList.toggle('active', button.dataset.unit === this.currentUnit);
				});
			}

			convertAllMeasurements(fromUnit, toUnit) {
				console.log('test');
				const inputs = this.querySelectorAll('tpt-measurement .field-rule-input');

				inputs.forEach((input) => {
					const value = parseFloat(input.value);

					if (isNaN(value)) return;

					let convertedValue = value;

					// Inch -> CM
					if (fromUnit === 'in' && toUnit === 'cm') {
						convertedValue = value * 2.54;
					}

					// CM -> Inch
					if (fromUnit === 'cm' && toUnit === 'in') {
						convertedValue = value / 2.54;
					}

					input.value = this.formatNumber(convertedValue);
				});
			}

			formatNumber(number) {
				return parseFloat(number.toFixed(2)).toString();
			}

			/**
			 * End
			 */

			connectedCallback() {
				const allNav = this.querySelectorAll('tpt-measurement-nav');
				this.selectProduct = this.querySelectorAll('tpt-measurement-select-product');
				this.measurementComponent = this;

				allNav.forEach((item) => {
					item.addEventListener('click', this.toScreen.bind(this));
				});

				this.selectProduct.forEach((item) => {
					item.addEventListener('click', this.selectedProduct.bind(this));
				});

				this.form = this.closest('form');

				const submitBtn = this.querySelector('button[type="submit"]');

				if (submitBtn) {
					submitBtn.addEventListener('click', this.handleSubmitClick.bind(this));
				}
			}

			handleSubmitClick(event) {
				console.log('SUBMIT FORM...');
				event.preventDefault();

				const isValid = this.validateCurrentStep();

				if (!isValid) return;

				// normalize phone trước khi submit
				// this.querySelectorAll('.tpt-field-phone').forEach((input) => {
				// 	input.value = input.value.replace(/[^\d+]/g, '');
				// });

				// submit form
				if (this.form) {
					this.form.requestSubmit();
				}
			}

			hiddenAllStep() {
				const allStep = this.querySelectorAll('.tpt-measurement__step');

				allStep.forEach((step) => {
					step.classList.remove('active');
				});
			}

			showNextStep(step) {
				this.hiddenAllStep();

				const targetStep = this.querySelector(`#${step}`);

				if (targetStep) {
					targetStep.classList.add('active');

					this.scrollTo({
						top: 0,
						behavior: 'smooth',
					});
				}
			}

			// validateCurrentStep() {
			// 	const currentStep = this.querySelector('.tpt-measurement__step.active');

			// 	if (!currentStep) return true;

			// 	const requiredInputs = currentStep.querySelectorAll('input[required], textarea[required], select[required]');

			// 	let isValid = true;

			// 	requiredInputs.forEach((input) => {
			// 		input.classList.remove('error');

			// 		input.setCustomValidity('');

			// 		if (!input.value.trim()) {
			// 			isValid = false;

			// 			input.classList.add('error');

			// 			input.setCustomValidity('This field is required.');

			// 			return;
			// 		}

			// 		if (input.type === 'email' && !input.validity.valid) {
			// 			isValid = false;

			// 			input.classList.add('error');

			// 			input.setCustomValidity('Please enter a valid email address.');
			// 		}
			// 	});

			// 	if (!isValid) {
			// 		const firstError = currentStep.querySelector('.error');

			// 		if (firstError) {
			// 			firstError.reportValidity();

			// 			firstError.focus({
			// 				preventScroll: false,
			// 			});
			// 		}
			// 	}

			// 	return isValid;
			// }

			getFieldLabel(input) {
				const name = input.name || '';

				const match = name.match(/\[(.*?)\]/);

				if (match) {
					return match[1];
				}

				return input.placeholder || 'Field';
			}

			validateCurrentStep() {
				const currentStep = this.querySelector('.tpt-measurement__step.active');

				if (!currentStep) return true;

				const errorContainer = currentStep.querySelector('.tpt-measurement-form__error');

				const requiredInputs = currentStep.querySelectorAll('input[required], textarea[required], select[required]');

				let isValid = true;
				let firstError = null;
				const errors = [];

				if (errorContainer) {
					errorContainer.innerHTML = '';
					errorContainer.classList.remove('active');
				}

				requiredInputs.forEach((input) => {
					input.classList.remove('error');

					const label = this.getFieldLabel(input);

					// Required validation
					if (!input.value.trim()) {
						isValid = false;

						input.classList.add('error');

						errors.push(`${label} is required.`);

						if (!firstError) firstError = input;

						return;
					}

					// Email validation
					if (input.type === 'email' && !input.validity.valid) {
						isValid = false;

						input.classList.add('error');

						errors.push(`${label} is invalid.`);

						if (!firstError) firstError = input;
					}

					// Phone validation
					if (input.classList.contains('tpt-field-phone')) {
						const normalizedPhone = input.value.replace(/[^\d+]/g, '');

						const phoneRegex = /^\+[1-9]\d{1,14}$/;

						if (!phoneRegex.test(normalizedPhone)) {
							isValid = false;

							input.classList.add('error');

							errors.push(`${label} must be a valid international phone number (example: +84912345678).`);

							if (!firstError) firstError = input;
						}
					}
				});

				if (!isValid) {
					if (errorContainer) {
						errorContainer.innerHTML = `
							<ul>
								${errors.map((error) => `<li>${error}</li>`).join('')}
							</ul>
						`;

						errorContainer.classList.add('active');
					}

					firstError?.focus({
						preventScroll: false,
					});
				}

				return isValid;
			}

			toScreen(event) {
				const nav = event.currentTarget;

				const nextStep = nav.getAttribute('data-to-screen');

				const type = nav.getAttribute('data-type');

				// Only validate when next button
				if (type === 'next') {
					const isValid = this.validateCurrentStep();

					if (!isValid) return;
				}

				if (nextStep == 'measurement-add-to-cart') {
					const addToCartButton = document.getElementById('MeasurementSubmitButton').click();
				} else {
					this.showNextStep(nextStep);
				}
			}

			setProductData(selectedItem) {
				const data = {
					'properties[Product related]': selectedItem.dataset.productTitle,
					'properties[_product_related_image]': selectedItem.dataset.productImage,
					'properties[_product_related_url]': selectedItem.dataset.productUrl,
				};

				console.log(data);

				Object.entries(data).forEach(([name, value]) => {
					const input = this.measurementComponent.querySelector(`[name="${name}"]`);
					if (input) input.value = value;
				});
			}

			selectedProduct(event) {
				const selectedItem = event.currentTarget;

				this.selectProduct.forEach((item) => {
					item.classList.remove('active');
				});

				selectedItem.classList.toggle('active');

				this.querySelector('[name="productTabInput"]').value = 'selected';

				this.setProductData(selectedItem);
			}
		},
	);
}

/**
 * Dropdown in cart
 */

if (!customElements.get('tpt-measure-dropdown')) {
	customElements.define(
		'tpt-measure-dropdown',
		class TptMeasureDropdown extends HTMLElement {
			constructor() {
				super();
			}

			connectedCallback() {
				const toggleButton = this.querySelector('tpt-measure-drop-toggle');

				toggleButton.addEventListener('click', this.toggleMeasure.bind(this));
			}

			toggleMeasure() {
				this.classList.toggle('active');
			}
		},
	);
}
